import {
  faChevronDown,
  faChevronRight,
  faLink,
  faSpinner,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'primereact/button'
import { Column, ColumnBodyOptions } from 'primereact/column'
import { DataTable, DataTableExpandedRows } from 'primereact/datatable'
import { classNames } from 'primereact/utils'
import { useEffect, useRef, useState } from 'react'
import { CertificateDocumentStatus } from '../../enums/CertificateDocumentStatus'
import { CertificateDocumentType } from '../../enums/CertificateDocumentType'
import { SchemeEcmType } from '../../enums/SchemeEcmType'
import useLazyLoadDataTable from '../../hooks/useLazyLoadDataTable'
import { useSignalR } from '../../hooks/useSignalR'
import useToastr from '../../hooks/useToastr'
import { ResultModel } from '../../models/result.model'
import CertificateListService from '../../services/CertificateListService'
import ConfirmationModal from '../../shared/confirmation-modal/ConfirmationModal'
import { findSortKey, getSortOrder } from '../../shared/datatable-helper/datatable-helper'
import { formatDate } from '../../shared/date-helper/DateHelper'
import { PaginatedRequestModel } from '../../shared/models/service-models/PaginatedRequest.model'
import { PaginatedResultModel } from '../../shared/models/service-models/PaginatedResult.model'
import ULTabsV2 from '../../shared/ul-tabs-v2/ULTabsV2'
import { ecmUnavailableHeader } from '../../utils/constants/ecm.constants'
import {
  AttachmentUploadingSuccessHeader,
  AttachmentUploadingSuccessToastMessage,
} from './../certificate-list-view/cetificate-list/certificate-details/shared/constants/CertificateUploadToastMessages'
import classes from './CertificatePendingDocumentList.module.scss'

import * as _ from 'lodash'
import { CertificateDocumentModel } from '../../shared/models/CertificateDocument.model'
import { FailedCertificateDocumentModel } from '../../shared/models/FailedCertificateDocument.model'
import { useCertificateDocumentRealTimeUpdates } from '../certificate-list-view/hooks/useCertificateDocumentRealTimeUpdates'

const CertificatePendingDocumentList = () => {
  const [activeTab, setActiveTab] = useState(0)

  const [list, setList] = useState([] as FailedCertificateDocumentModel[])
  const [expandedRows, setExpandedRows] = useState<DataTableExpandedRows | any>(list)

  const [selectedRows, setSelectedRows] = useState([] as any[])
  const [isLoadingList, setIsLoadingList] = useState(false)
  const [showDeleteFileConfirmation, setShowDeleteFileConfirmation] = useState(false)

  const { showSuccess, showError, showWarning } = useToastr()
  const [linkAllButtonLabel, setLinkAllButtonLabel] = useState('')
  const [deleteAllButtonLabel, setDeleteAllButtonLabel] = useState('')
  const [isSingleActionButtonDisabled, setIsSingleActionButtonDisabled] = useState(false)
  const [isMultipleButtonDisabled, setIsMultipleButtonDisabled] = useState(false)
  const [isLinkAllClicked, setIsLinkAllClicked] = useState(false)
  const [isDeleteAllClicked, setIsDeleteAllClicked] = useState(false)
  const [supportingDocForDeletion, setSupportingDocForDeletion] = useState<string | null>(null)

  const hubUrl = (process.env.REACT_APP_GMAE2E_URL + '/hubs/pending_document_list') as string
  const { connection: signalRConnection } = useSignalR(hubUrl)
  useCertificateDocumentRealTimeUpdates(
    signalRConnection,
    list.map(doc => doc.documentId),
    handleCertificateDocumentUpdate
  )
  const functionHubUrl = (process.env.REACT_APP_GMAE2E_FUNC_URL + '/api') as string
  const { connection: functionSignalRConnection } = useSignalR(functionHubUrl, true)

  const gmaLibraryColumns: any = [
    {
      field: 'certificateNumber',
      header: 'Certificate Number',
      sortKey: 'CertificateNumber',
      width: '17%',
    },
    {
      field: 'certificateScheme',
      header: 'Certificate Scheme',
      sortKey: 'CertificateScheme',
      width: '15%',
    },
    {
      field: 'documentCategoryText',
      header: 'Document Category',
      sortKey: 'DocumentCategory',
      width: '12%',
    },
    {
      field: 'documentFileName',
      header: 'Document File Name',
      sortKey: 'DocumentFileName',
      width: '15%',
    },
    {
      field: 'dateAttached',
      header: 'Date Attached',
      sortKey: 'DateAttached',
      width: '10%',
    },
    {
      field: 'lastAttemptedUpload',
      header: 'Last Attempted Upload',
      sortKey: 'LastAttemptedUpload',
      width: '10%',
    },
  ]

  const rpLibraryColumns: any = [
    {
      field: 'certificateNumber',
      header: 'Certificate Number',
      sortKey: 'CertificateNumber',
      width: '17%',
    },
    {
      field: 'certificateScheme',
      header: 'Certificate Scheme',
      sortKey: 'CertificateScheme',
      width: '15%',
    },
    {
      field: 'contentGroup',
      header: 'Content Group',
      sortKey: 'ContentGroup',
      width: '12%',
    },
    {
      field: 'documentFileName',
      header: 'Document File Name',
      sortKey: 'DocumentFileName',
      width: '15%',
    },
    {
      field: 'dateAttached',
      header: 'Date Attached',
      sortKey: 'DateAttached',
      width: '10%',
    },
    {
      field: 'lastAttemptedUpload',
      header: 'Last Attempted Upload',
      sortKey: 'LastAttemptedUpload',
      width: '10%',
    },
  ]

  const [columns, setColumns] = useState(gmaLibraryColumns)
  const [gmaLibraryCount, setGmaLibraryCount] = useState(0)
  const [rpLibraryCount, setRPLibraryCount] = useState(0)

  const dataTableRef = useRef<any>(null)
  const {
    handleSort,
    sortField,
    sortOrder,
    currentPageNo,
    itemsPerPage,
    setHasNextPage,
    reloadList,
  } = useLazyLoadDataTable(50, 'DateAttached', dataTableRef, loadList)

  useEffect(() => {
    getFailedCounts()
  }, [])

  useEffect(() => {
    let schemeEcmType = activeTab + 1
    setColumns(schemeEcmType == SchemeEcmType.GMA ? gmaLibraryColumns : rpLibraryColumns)
    resetValues()
    reloadList()
    setExpandedRows(list)
  }, [activeTab])

  useEffect(() => {
    if (selectedRows.length > 0) {
      setLinkAllButtonLabel('Link All Selected to WB and ECM TIC')
      setDeleteAllButtonLabel('Delete All Selected')
      setIsSingleActionButtonDisabled(true)
    } else {
      setLinkAllButtonLabel('Link All to WB and ECM TIC')
      setDeleteAllButtonLabel('Delete All')
      setIsSingleActionButtonDisabled(false)
    }
  }, [selectedRows])

  useEffect(() => {
    if (list?.length > 0) setIsMultipleButtonDisabled(false)
    else setIsMultipleButtonDisabled(true)
  }, [list])

  useEffect(() => {
    if (functionSignalRConnection) {
      functionSignalRConnection.on('ecm-uploading-certificate-success', result => {
        const jsonResult = JSON.parse(result)
        signalRUploadSucessMessageProcess(jsonResult)
      })
      functionSignalRConnection.on('ecm-uploading-certificate-failed', result => {
        const jsonResult = JSON.parse(result)
        signalRUploadFailedMessageProcess(jsonResult)
      })

      functionSignalRConnection.on(
        'ecm-uploading-certificate-rp-pendingdocument-success',
        result => {
          const jsonResult = JSON.parse(result)
          signalRUploadSucessMessageProcess(jsonResult)
        }
      )

      functionSignalRConnection.on(
        'ecm-uploading-certificate-rp-pendingdocument-failed',
        result => {
          const jsonResult = JSON.parse(result)
          signalRUploadFailedMessageProcess(jsonResult)
        }
      )

      functionSignalRConnection.on('ecm-uploading-certificate-rp-failed', result => {
        const jsonResult = JSON.parse(result)
        signalRUploadFailedMessageProcess(jsonResult)
      })
      functionSignalRConnection.on('ecm-uploading-certificate-rp-flyout-failed', result => {
        const jsonResult = JSON.parse(result)
        signalRUploadFailedMessageProcess(jsonResult)
      })

      functionSignalRConnection.on('ecm-uploading-certificate-rp-attachment-failed', result => {
        const jsonResult = JSON.parse(result)
        signalRUploadFailedMessageProcess(jsonResult)
      })
    }
  }, [functionSignalRConnection])

  const signalRUploadSucessMessageProcess = (jsonResult: any) => {
    if (!jsonResult?.certificateDocumentIds || jsonResult?.certificateDocumentIds?.length <= 0)
      return

    setList((prevList: any) => {
      return prevList.filter((doc: any) => {
        return !jsonResult.certificateDocumentIds.includes(doc.documentId)
      })
    })

    getFailedCounts()

    showSuccess(AttachmentUploadingSuccessHeader, AttachmentUploadingSuccessToastMessage)
  }

  const signalRUploadFailedMessageProcess = (jsonResult: any) => {
    if (!jsonResult?.certificateDocumentIds || jsonResult?.certificateDocumentIds?.length <= 0)
      return

    setList((prevList: any) => {
      const newList = prevList.map((document: FailedCertificateDocumentModel) => {
        if (
          jsonResult.certificateDocumentIds.find(
            (resultDocId: any) => document.documentId == resultDocId
          )
        ) {
          return {
            ...document,
            status:
              document.status == CertificateDocumentStatus.TestReportDuplicateLinkToEcmInProgress ||
              document.status == CertificateDocumentStatus.TestReportDuplicateLinkToEcmFailed
                ? CertificateDocumentStatus.TestReportDuplicateLinkToEcmFailed
                : CertificateDocumentStatus.UploadToEcmFailed,
          }
        }
        return document
      })
      return newList
    })

    showWarning(
      ecmUnavailableHeader,
      `Uploading of documents to ECM is unsuccessful. Check status bar if ECM is back on-line and retry to upload your selected files. ` +
        `If issue still persists, please contact GMAWB Support team.`
    )

    getFailedCounts()
  }

  async function loadList() {
    setIsLoadingList(true)

    const model: PaginatedRequestModel = {
      skip: currentPageNo,
      take: itemsPerPage,
      searchString: '',
      sort: findSortKey(columns, sortField, 'DateAttached'),
      sortBy: getSortOrder(sortOrder),
    }

    const result = await getList(model).catch(error => {
      showError(`Error`, `Error while getting the data.`)
    })

    if (result?.isSuccess) {
      let records = result.data.records || []

      setHasNextPage(result.data.hasNextPage)

      records.forEach((certificateDocument: FailedCertificateDocumentModel) => {
        certificateDocument.dateAttached = formatDate(certificateDocument.dateAttached)

        certificateDocument.lastAttemptedUpload = formatDate(
          certificateDocument.lastAttemptedUpload
        )

        certificateDocument.documentCategoryText = getCertificateDocumentTypeText(
          certificateDocument.documentCategory
        )
      })

      setList(prevList => {
        let newList = currentPageNo == 1 ? [] : JSON.parse(JSON.stringify(prevList))
        newList.push(...records)

        return newList
      })
    }

    setIsLoadingList(false)
  }

  const getList = async (
    model: PaginatedRequestModel
  ): Promise<ResultModel<PaginatedResultModel<FailedCertificateDocumentModel[]>>> => {
    let schemeEcmType = activeTab + 1
    return CertificateListService.getCertificateDocumentsFailedEcmUpload(model, schemeEcmType)
  }

  const getFailedCounts = async () => {
    let gmaLibraryCount = await CertificateListService.getCertificateDocumentsFailedEcmUploadCount(
      SchemeEcmType.GMA
    )
    let rpLibraryCount = await CertificateListService.getCertificateDocumentsFailedEcmUploadCount(
      SchemeEcmType.RP
    )

    setGmaLibraryCount(gmaLibraryCount.isSuccess ? gmaLibraryCount.data : 0)
    setRPLibraryCount(rpLibraryCount.isSuccess ? rpLibraryCount.data : 0)
  }

  const getCertificateDocumentTypeText = (type?: CertificateDocumentType) => {
    switch (type) {
      case CertificateDocumentType.Certificate:
        return 'Certificate'
      case CertificateDocumentType.TestReport:
        return 'Test Report'
      case CertificateDocumentType.Others:
        return 'Internal Files'
      case CertificateDocumentType.R2CPackage:
        return 'R2C Package'
      case CertificateDocumentType.InspectionSurveillance:
        return 'Inspection/Surveillance'
    }
  }

  const getLinkDisplay = (status: CertificateDocumentStatus) => {
    if (status == CertificateDocumentStatus.TestReportDuplicateLinkToEcmFailed) {
      return 'Continue Linking Existing File from ECM TIC'
    } else {
      return 'Link File to WB and ECM TIC'
    }
  }

  const handleSingleDelete = (data: any) => {
    const currentList = [...selectedRows]
    currentList.push(data)
    setSelectedRows(currentList)
    setIsDeleteAllClicked(false)
    setSupportingDocForDeletion(null)
  }

  const handleMultipleDelete = () => {
    if (selectedRows?.length <= 0) {
      setIsDeleteAllClicked(true)
      setSelectedRows(list)
    } else {
      setIsDeleteAllClicked(false)
    }

    setSupportingDocForDeletion(null)
    setShowDeleteFileConfirmation(true)
  }

  const handleDelete = async () => {
    if (selectedRows?.length <= 0 && supportingDocForDeletion == null)
      return showError('Failed!', 'There are no selected row(s).')

    setIsLoadingList(true)
    resetDialog()

    let documentIds = []

    if (supportingDocForDeletion != null) {
      documentIds = [supportingDocForDeletion]
    } else {
      documentIds = _.flatMapDeep(selectedRows, s => {
        let supportingDocsIds = _.map(s.supportingDocuments, 'documentId')
        if (s.status == CertificateDocumentStatus.UploadToEcmFailed)
          return [s.documentId, supportingDocsIds]
        else return [supportingDocsIds]
      })
    }

    let schemeEcmType = activeTab + 1

    const result = await CertificateListService.deleteBatchCertificateDocumentsFailedEcmUpload(
      {
        documentIds: documentIds,
        deleteAll: isDeleteAllClicked,
      },
      schemeEcmType
    ).catch(error => {})

    if (result?.isSuccess) {
      showSuccess('Success!', 'Attachment(s) has been deleted. ')
    } else {
      showError('Error!', result ? result.message : `Attachment(s) has not been deleted.`)
    }
    reloadList()
    resetValues()
  }

  const handleCancelDelete = () => {
    resetValues()
    resetDialog()
  }

  const handleMultipleLinkToEcm = () => {
    if (selectedRows?.length <= 0) {
      setIsLinkAllClicked(true)
      setSelectedRows(list)
      handleConfirmLinkToEcm(list)
    } else {
      setIsLinkAllClicked(false)
      handleConfirmLinkToEcm(selectedRows)
    }
  }

  const handleSingleLinkToEcm = async (data: FailedCertificateDocumentModel) => {
    const currentList = [...selectedRows]
    currentList.push(data)
    setSelectedRows(currentList)

    setIsLoadingList(true)
    resetDialog()

    let documentIds = _.flattenDeep([
      data.documentId,
      _.map(data.supportingDocuments, 'documentId'),
    ])

    await reuploadAndLinkDocsBatch(documentIds)
  }

  const handleConfirmLinkToEcm = async (list: any[]) => {
    if (list?.length <= 0) return showError('Failed!', 'There are no selected row(s).')

    setIsLoadingList(true)
    resetDialog()

    let documentIds = _.flatMapDeep(list, s => {
      let supportingDocsIds = _.map(s.supportingDocuments, 'documentId')
      return [s.documentId, supportingDocsIds]
    })

    await reuploadAndLinkDocsBatch(documentIds)
  }

  const reuploadAndLinkDocsBatch = async (documentIds: any) => {
    let schemeEcmType = activeTab + 1

    CertificateListService.reuploadAndLinkDocsBatch(
      {
        certificateDocumentIds: documentIds,
        isLinkAll: isLinkAllClicked,
      },
      schemeEcmType
    )
      .then(result => {
        if (!result.isSuccess) showError('Error!', result.message)
      })
      .catch(err => {
        showWarning(
          ecmUnavailableHeader,
          'Something went wrong while accessing ECM. Please try again later.'
        )
      })
      .finally(() => setIsLoadingList(false))

    resetValues()
  }

  const resetDialog = () => {
    setShowDeleteFileConfirmation(false)
  }

  const resetValues = () => {
    setSelectedRows([])
    setSupportingDocForDeletion(null)
    setIsLinkAllClicked(false)
    setIsDeleteAllClicked(false)
    getFailedCounts()
  }

  const tableColumnHeader = (col: any) => (
    <div>
      <span title={col.header}>{col.header}</span>
    </div>
  )

  const tableColumnBody = (rowData: any, col: any) => {
    const stockClassName = classNames({
      'text-overflow-ellipsis': true,
    })
    return (
      <div title={rowData[col.field]} className={stockClassName}>
        {rowData[col.field]}
      </div>
    )
  }

  const renderEmptyDatatable = () => {
    return (
      <div className={classes['datatable-emptymessage-container']}>
        <div>
          <div className={classes['datatable-emptymessage-label']}>
            No pending documents available
          </div>
        </div>
      </div>
    )
  }

  const renderDynamicColumns = (columnsToRender: SchemeEcmType) => {
    let columns: any = columnsToRender == SchemeEcmType.GMA ? gmaLibraryColumns : rpLibraryColumns

    return columns.map((col: any) => {
      return (
        <Column
          sortable
          key={col.field}
          field={col.field}
          header={tableColumnHeader(col)}
          style={{ flexGrow: 1, flexBasis: col.width, width: col.width }}
          body={tableColumnBody.bind(col)}
        />
      )
    })
  }

  const gridLinkActionTemplate = (rowData: FailedCertificateDocumentModel) => {
    let hasReprocessingSupportingDoc = _.some(rowData.supportingDocuments, [
      'status',
      CertificateDocumentStatus.RetryUploadToEcmTicInProgress,
    ])

    return (
      <div className={classes['gridaction-container']}>
        {(rowData.status == CertificateDocumentStatus.UploadToEcmFailed ||
          rowData.status == CertificateDocumentStatus.TestReportDuplicateLinkToEcmFailed ||
          (rowData.status == CertificateDocumentStatus.LinkedToWbAndEcmTic &&
            rowData.supportingDocuments.length &&
            !hasReprocessingSupportingDoc)) && (
          <Button
            className={`${classes['text-btn']} ${classes['linkToWbAndEcm']}`}
            onClick={() => {
              handleSingleLinkToEcm(rowData)
            }}
            title={getLinkDisplay(rowData.status)}
            disabled={isSingleActionButtonDisabled}
          >
            <span>
              {' '}
              <FontAwesomeIcon className={classes['icons']} icon={faLink} />
              {getLinkDisplay(rowData.status)}
            </span>
          </Button>
        )}
        {(rowData.status == CertificateDocumentStatus.RetryUploadToEcmTicInProgress ||
          rowData.status == CertificateDocumentStatus.TestReportDuplicateLinkToEcmInProgress ||
          hasReprocessingSupportingDoc) && (
          <span>
            <FontAwesomeIcon icon={faSpinner} spin={true} />
          </span>
        )}
      </div>
    )
  }

  const gridDeleteActionTemplate = (rowData: any, props: any) => {
    return (
      <div className={classes['gridaction-container']}>
        {rowData.status == CertificateDocumentStatus.UploadToEcmFailed && (
          <Button
            className="p-button-rounded p-button-secondary p-button-text p-button-sm"
            title="Delete Attachment"
            onClick={() => {
              setShowDeleteFileConfirmation(true)
              handleSingleDelete(rowData)
            }}
            disabled={isSingleActionButtonDisabled}
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        )}
      </div>
    )
  }

  const hideColumnHeader = <span></span>

  const deleteConfirmationMessage = () => {
    return (
      <span>
        The document(s) will be deleted from GMAWB File Storage.
        <br />
        <br />
        Would you like to continue?
      </span>
    )
  }

  const getRowClassName = (data: any) => {
    if (
      data.status == CertificateDocumentStatus.RetryUploadToEcmTicInProgress ||
      data.status == CertificateDocumentStatus.TestReportDuplicateLinkToEcmInProgress
    ) {
      return classes['already-selected']
    }

    return ''
  }

  const HeaderContainer = () => {
    return (
      <>
        <div className={classes['header-container']}>
          <div className={classes['button-container']}>
            <button
              className={`ul-button -small ${classes['link-btn']}`}
              onClick={handleMultipleLinkToEcm}
              disabled={isMultipleButtonDisabled && !isLoadingList}
            >
              {linkAllButtonLabel}
            </button>
            <button
              className={`ul-button -small ${classes['delete-btn']}`}
              onClick={handleMultipleDelete}
              disabled={isMultipleButtonDisabled && !isLoadingList}
            >
              {deleteAllButtonLabel}
            </button>
          </div>
          <div className={classes['note-container']}>
            <span>
              Note: All documents listed are pending documents due to an error while saving on ECM
              TIC
            </span>
          </div>
        </div>
      </>
    )
  }

  const supportingDocumentTableTemplate = (data: any, opt: ColumnBodyOptions) => (
    <div
      className={`${classes['col-text-div']}
        } ul-grid__column`}
    >
      {data[opt.field]}
    </div>
  )

  const supportingDocumentTableDeleteColumnTemplate = (
    data: FailedCertificateDocumentModel,
    opt: ColumnBodyOptions
  ) => {
    return (
      <div className={classes['gridaction-container']}>
        <Button
          className="p-button-rounded p-button-secondary p-button-text p-button-sm"
          title="Delete Attachment"
          onClick={() => {
            setShowDeleteFileConfirmation(true)
            setSelectedRows([])
            setIsDeleteAllClicked(false)
            setSupportingDocForDeletion(data.documentId)
          }}
          disabled={isSingleActionButtonDisabled}
        >
          <FontAwesomeIcon icon={faTrash} />
        </Button>
      </div>
    )
  }

  const rowExpansionTemplate = (rowData: FailedCertificateDocumentModel) => {
    return (
      <div className={`${classes['supporting-documents-container']}`}>
        <span className={`${classes['supporting-documents-container-header']}`}>
          Supporting Documents
        </span>
        <DataTable
          value={rowData.supportingDocuments}
          className={classes['supporting-documents-table']}
          showGridlines={true}
        >
          <Column
            header="Document File Name"
            field="documentFileName"
            body={supportingDocumentTableTemplate}
            className={`${classes['table-col']} ${classes['col-documentFileName']}`}
          />
          <Column
            header="Content Group"
            field="contentGroup"
            body={supportingDocumentTableTemplate}
            className={`${classes['table-col']} ${classes['col-contentGroup']}`}
          />
          <Column
            header="Type"
            field="type"
            body={supportingDocumentTableTemplate}
            className={`${classes['table-col']} ${classes['col-type']}`}
          />
          <Column
            align="center"
            style={{
              flexGrow: 1,
              flexBasis: '2%',
              width: '2%',
            }}
            header=""
            field="delete"
            body={supportingDocumentTableDeleteColumnTemplate}
            className={`${classes['table-col']} ${classes['col-delete']}`}
          />
        </DataTable>
      </div>
    )
  }

  function handleCertificateDocumentUpdate(updatedDocument: CertificateDocumentModel) {
    setList((prevList: any) => {
      const newList = prevList.map((document: FailedCertificateDocumentModel) => {
        if (document.documentId !== updatedDocument.id) return document

        return {
          ...document,
          status: updatedDocument.status,
          lastAttemptedUpload: formatDate(updatedDocument.modifiedDateUtc),
        }
      })
      return newList
    })

    getFailedCounts()
  }

  const components = [
    {
      headerName: 'GMA Library',
      components: (
        <>
          {HeaderContainer()}
          <div className={`${classes['datatable-container']}`}>
            <DataTable
              dataKey="documentId"
              emptyMessage={renderEmptyDatatable()}
              size="small"
              value={list}
              responsiveLayout="scroll"
              lazy
              scrollable
              resizableColumns
              scrollDirection="both"
              selection={selectedRows}
              removableSort
              onSort={e => handleSort(e)}
              sortField={sortField}
              sortOrder={sortOrder}
              onSelectionChange={e => setSelectedRows(e.value)}
              loading={isLoadingList}
              ref={dataTableRef}
              rowClassName={getRowClassName}
            >
              <Column
                header={hideColumnHeader}
                selectionMode="multiple"
                headerClassName={`${classes['hideHeaderCheckbox']}`}
                style={{
                  flexGrow: 1,
                }}
                columnKey="select"
                alignFrozen="left"
                reorderable={false}
                frozen
              />
              {renderDynamicColumns(SchemeEcmType.GMA)}
              <Column
                align="right"
                header=""
                style={{
                  flexGrow: 1,
                  flexBasis: '16%',
                  width: '16%',
                }}
                body={gridLinkActionTemplate}
              ></Column>
              <Column
                align="center"
                header=""
                style={{
                  flexGrow: 1,
                  flexBasis: '2%',
                  width: '2%',
                }}
                body={gridDeleteActionTemplate}
              ></Column>
            </DataTable>
          </div>
        </>
      ),
    },
    {
      headerName: 'R/P Library',
      components: (
        <>
          {HeaderContainer()}
          <div className={`${classes['datatable-container']}`}>
            <DataTable
              dataKey="documentId"
              emptyMessage={renderEmptyDatatable()}
              size="small"
              value={list}
              responsiveLayout="scroll"
              lazy
              scrollable
              resizableColumns
              scrollDirection="both"
              selection={selectedRows}
              removableSort
              selectionMode="checkbox"
              onSort={e => handleSort(e)}
              sortField={sortField}
              sortOrder={sortOrder}
              onSelectionChange={e => setSelectedRows(e.value)}
              loading={isLoadingList}
              ref={dataTableRef}
              rowClassName={getRowClassName}
              rowExpansionTemplate={rowExpansionTemplate}
              expandedRows={expandedRows}
            >
              <Column
                columnKey="select"
                reorderable={false}
                field=""
                header=""
                alignFrozen="left"
                frozen
                body={(data: FailedCertificateDocumentModel) => {
                  if (data.supportingDocuments.length <= 0) return <></>

                  return (
                    <FontAwesomeIcon
                      cursor={'pointer'}
                      onClick={() => {
                        setList((prevList: any) => {
                          return prevList.map((document: FailedCertificateDocumentModel) => {
                            if (data.documentId == document.documentId) {
                              document.isExpanded = !data.isExpanded
                            }
                            return document
                          })
                        })

                        setExpandedRows((prevExpandedRows: any[]) => {
                          let newExpandedRows: any = _.cloneDeep(list)
                          let expandedRows = _.filter(newExpandedRows, f => {
                            return f.isExpanded
                          })
                          expandedRows.forEach(row => {
                            newExpandedRows[row.documentId] = true
                          })

                          return newExpandedRows
                        })
                      }}
                      icon={data.isExpanded ? faChevronDown : faChevronRight}
                    />
                  )
                }}
                style={{
                  maxWidth: '38px',
                  width: '38px',
                  borderLeft: 'none',
                  flex: 'none',
                  justifyContent: 'right',
                  borderRadius: 'unset',
                }}
                headerStyle={{ borderLeft: 'none', flex: 'none' }}
              ></Column>

              <Column
                header={hideColumnHeader}
                selectionMode="multiple"
                headerClassName={`${classes['hideHeaderCheckbox']}`}
                style={{
                  flexGrow: 1,
                }}
                columnKey="select"
                alignFrozen="left"
                reorderable={false}
                frozen
              />
              {renderDynamicColumns(SchemeEcmType.RP)}
              <Column
                align="right"
                header=""
                style={{
                  flexGrow: 1,
                  flexBasis: '16%',
                  width: '16%',
                }}
                body={gridLinkActionTemplate}
              ></Column>
              <Column
                align="center"
                header=""
                style={{
                  flexGrow: 1,
                  flexBasis: '2%',
                  width: '2%',
                }}
                body={gridDeleteActionTemplate}
              ></Column>
            </DataTable>
          </div>
        </>
      ),
    },
  ]

  return (
    <>
      <div className={`${classes['page-container']}`}>
        <ULTabsV2
          containerClassName={`${classes['ul-tab-container']}`}
          contentClassName={`${classes['ul-tab-content']}`}
          components={components}
          tabsCounter={[gmaLibraryCount, rpLibraryCount]}
          callBackUponTabChange={tab => {
            setList([])
            setActiveTab(tab)
          }}
        />
      </div>

      <ConfirmationModal
        visible={showDeleteFileConfirmation}
        onCancel={() => handleCancelDelete()}
        onConfirm={() => handleDelete()}
        headerDisplay={'Delete File Confirmation'}
        confirmationMessageHTML={deleteConfirmationMessage()}
        buttonNoDisplay={`No`}
        buttonYesDisplay={`Yes`}
      />
    </>
  )
}

export default CertificatePendingDocumentList
